export const APP_NAME = 'reselling_listings_perseus';
